import { render, staticRenderFns } from "./VirtualKeyboard.vue?vue&type=template&id=f7d419a2&scoped=true&"
import script from "./VirtualKeyboard.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboard.vue?vue&type=style&index=0&id=f7d419a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d419a2",
  null
  
)

export default component.exports